import { User } from '../models/user'
import { Company } from '../models/company'

export interface UserStateType {
  users: User[]
  user: User | null
  companies: Company[]
  company: Company | null
}

const UserState: () => UserStateType = () => ({
  users: [],
  user: null,
  companies: [],
  company: null,
})

export default UserState
